import { useEffect, useState, ReactElement } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { LoadingIndicator } from '@ui/feedback'
import { useConfigStore } from '@stores'

interface Props {
  element: ReactElement
}

const ProtectedRoute = ({ element: Component }: Props): ReactElement => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0()
  const { auth0Audience, auth0Scopes } = useConfigStore()
  const [Element, setElement] = useState<ReactElement>(<LoadingIndicator />)

  useEffect(() => {
    if (isLoading) {
      setElement(<LoadingIndicator />)
      return
    }

    if (!isAuthenticated) {
      loginWithRedirect({
        authorizationParams: {
          audience: auth0Audience,
          scope: auth0Scopes,
        },
      })
      setElement(<LoadingIndicator />)
      return
    }

    setElement(Component)
  }, [isLoading, isAuthenticated, Component, loginWithRedirect, auth0Audience, auth0Scopes])

  return Element
}

export default ProtectedRoute
